import PropTypes from "prop-types";
import { Alert, Autocomplete, Box, Button, Chip, TextField, Typography } from "@mui/material";
import { Search, Clear } from "@mui/icons-material";
const names = {
  fechaDesde: "Desde",
  fechaHasta: "Hasta",
  comercio: "Comercio",
  pasarela: "Pasarela",
  servicio: "Servicio",
  tipoPasarela: "Tipo de pasarela",
  tipoFuente: "Tipo de fuente",
};
export const FiltrosGerencia = ({
  filtros,
  onFiltrosChange,
  onBuscar,
  onLimpiar,
  onRemove,
  opcionesFiltros = {},
  loading,
  vistaActual,
  filtrosAplicados = {},
  validation,
}) => {
  const fields = [
    vistaActual === "recaudo" ? ["tipoFuente", "tiposFuente"] : ["tipoPasarela", "tiposPasarela"],
    ["comercio", "comercios"],
    ["pasarela", "pasarelas"],
    ["servicio", "servicios"],
  ];
  const active = Object.entries(filtrosAplicados).filter(([, value]) => value);
  const pending = Object.keys(names).some(
    (key) => (filtros[key] || "") !== (filtrosAplicados[key] || "")
  );
  return (
    <Box
      component="form"
      noValidate
      onSubmit={(event) => {
        event.preventDefault();
        onBuscar();
      }}
      sx={{
        p: 2.5,
        bgcolor: "background.default",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        my: 2.5,
      }}
    >
      <Box
        sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 2 }}
      >
        <Typography variant="subtitle2" fontWeight="bold">
          Filtros de consulta
        </Typography>
        {pending && (
          <Typography variant="caption" color="text.secondary">
            Cambios pendientes de aplicar
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2,minmax(0,1fr))",
            lg: "repeat(3,minmax(0,1fr))",
          },
          gap: 2,
          "& .MuiInputBase-root": { minHeight: 44, fontSize: ".875rem" },
        }}
      >
        {["fechaDesde", "fechaHasta"].map((key) => (
          <TextField
            key={key}
            type="date"
            name={key}
            label={names[key]}
            value={filtros[key]}
            onChange={(event) => onFiltrosChange(key, event.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={
              key === "fechaDesde"
                ? { max: filtros.fechaHasta || undefined }
                : { min: filtros.fechaDesde || undefined }
            }
            helperText={
              key === "fechaDesde" ? "Desde las 00:00" : "Hasta las 23:59 · hora de Colombia"
            }
          />
        ))}
        {fields.map(([key, options]) => (
          <Autocomplete
            key={key}
            options={opcionesFiltros[options] || []}
            value={filtros[key] || null}
            onChange={(_, value) => onFiltrosChange(key, value || "")}
            noOptionsText="Sin opciones"
            renderInput={(params) => <TextField {...params} label={names[key]} />}
          />
        ))}
      </Box>
      {validation && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {validation}
        </Alert>
      )}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 2 }}>
        <Button
          type="button"
          onClick={onLimpiar}
          startIcon={<Clear />}
          sx={{ textTransform: "none", color: "text.secondary" }}
        >
          Limpiar
        </Button>
        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          startIcon={<Search />}
          sx={{
            textTransform: "none",
            bgcolor: "#1a73e8",
            color: "#fff",
            "&:hover": { bgcolor: "#155fc0" },
          }}
        >
          Aplicar filtros
        </Button>
      </Box>
      {active.length > 0 && (
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 2 }}>
          {active.map(([key, value]) => (
            <Chip
              key={key}
              label={`${names[key]}: ${value}`}
              onDelete={() => onRemove(key)}
              size="small"
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
FiltrosGerencia.propTypes = {
  filtros: PropTypes.object.isRequired,
  onFiltrosChange: PropTypes.func.isRequired,
  onBuscar: PropTypes.func.isRequired,
  onLimpiar: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  opcionesFiltros: PropTypes.object,
  loading: PropTypes.bool,
  vistaActual: PropTypes.string,
  filtrosAplicados: PropTypes.object,
  validation: PropTypes.string,
};
